<template>
    <fragment>
        <admin-nav-bar v-if="this.isSiteAdminUser"/>
        <HeaderNav :items="navItems" :program-enabled="programEnabled"/>
        <div v-if="behalfData.become_user_active" id="become-user-header">
            Working as {{ behalfData.become_user.firstname }} {{ behalfData.become_user.lastname }} &nbsp;
            <a v-tooltip="'Log back in as me'" href="/logout">
                <exit-to-app title="Log back in as me" :size="18" fillColor="#fff"/>
            </a>
        </div>
        <admin-sub-nav-bar v-if="this.isAdminUser"/>
        <project-manager-sub-nav-bar v-else-if="this.isProjectManagerNavBarAllowed"/>
    </fragment>
</template>

<script>

import './style.scss'
import VueStripeMenu from 'vue-stripe-menu'
import 'vue-stripe-menu/dist/vue-stripe-menu.css'
import globalSearch from "../GlobalSearch/GlobalSearch";
import {Fragment} from 'vue-fragment'

import {EventBus} from "../../event-bus";
import {mapGetters, mapState} from "vuex";
import AdminNavBar from "./AdminNavBar";
import AdminSubNavBar from "./AdminSubNavBar";
import ProjectManagerSubNavBar from "./ProjectManagerSubNavBar";

import {
    ExitToApp
} from '../icons';
import HeaderNav from "./HeaderNav";

export default {
    name: "NavBar",
    components: {
        HeaderNav,
        AdminNavBar,
        AdminSubNavBar,
        globalSearch,
        VueStripeMenu,
        ProjectManagerSubNavBar,
        ExitToApp,
        Fragment,
    },
    computed: {
        ...mapGetters('AuthStore', [
            'isSiteAdminUser',
            'isAdminUser',
            'isAccountManagerRole',
            'isConfidentialUser'
        ]),
        ...mapState('AuthStore', {
            sessionUser: 'user',
            sessionAccount: 'account',
            role: 'role'
        }),
        behalfData(){
            return JSON.parse(this.onBehalfData);
        }
    },
    props: ['navItems', 'helpNavItems', 'onBehalfData', 'programEnabled'],
    methods: {
        hasSubMenu(){
            return this.isSiteAdminUser || this.isAccountManagerRole;
        },
        isProjectManagerNavBarAllowed() {
            return this.isAccountManagerRole || this.isConfidentialUser
        }
    }
}
</script>
<style scoped>

.user-icon-menu {
    margin: auto;
}

#become-user-header {
    font-weight: 600;
    color: white;
    background: #8e3b82;
    padding: 4px;
    justify-content: center;
    display: flex;
    font-size: 13px;
}

#become-user-header a {
    color: white;
    font-weight: 200;
}
</style>
